import type { User } from '@supabase/supabase-js';
import { supabase } from '../supabaseClient.ts';

/** Send the browser to Google, then back to /welcome with a session. */
export async function signInWithGoogle(): Promise<string | null> {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: `${window.location.origin}/welcome`,
      queryParams: { prompt: 'select_account' },
    },
  });
  return error?.message ?? null;
}

/** First/last name from Google (or leftover email-signup metadata). */
export function namesFromAuthUser(user: User): { firstName: string; lastName: string } {
  const meta = (user.user_metadata ?? {}) as Record<string, unknown>;
  const asString = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

  const first = asString(meta.first_name) || asString(meta.given_name);
  const last = asString(meta.last_name) || asString(meta.family_name);
  if (first || last) return { firstName: first, lastName: last };

  const full = asString(meta.full_name) || asString(meta.name);
  if (!full) return { firstName: '', lastName: '' };

  const [head, ...rest] = full.split(/\s+/);
  return { firstName: head ?? '', lastName: rest.join(' ') };
}
